var enGBTranslation = {
    "contact_us.buttonText": "Help",
    "contact_us.error.email": "Please enter a valid email",
    "contact_us.error.general": "Oops... Something went wrong. Please try again.",
    "contact_us.error.minimum_two_chars": "Should be at least 2 chars long",
    "contact_us.placeholders.email": "Email Address",
    "contact_us.placeholders.name": "Full Name",
    "contact_us.placeholders.text": "How can we help?",
    "contact_us.send": "Send",
    "contact_us.subtitle": "Fill in your details, write your question, and we will get back to you",
    "contact_us.success.ok": "Ok",
    "contact_us.success.subtitle": "We got your message and will get back to you as soon as possible.",
    "contact_us.success.title": "Thanks {{name}}!",
    "contact_us.title": "Ask us anything",
    "cookie_consent.customize.categories.essential.description": "",
    "cookie_consent.customize.categories.essential.title": "",
    "cookie_consent.customize.categories.performance.description": "These help us measure performance and analyse visits to our site so we can keep improving our experience, and enables us to personalise offers",
    "cookie_consent.customize.categories.performance.title": "",
    "cookie_consent.customize.confirm_btn_title": "",
    "cookie_consent.customize.title": "Customise cookies",
    "cookie_consent.information.accept_btn_title": "",
    "cookie_consent.information.cookies_policy_link_text": "",
    "cookie_consent.information.customize_btn_title": "Customise",
    "cookie_consent.information.description": "We use cookies and other technologies to provide you with the best possible user experience and to personalise advertising on and off our website. In addition, our partners may use cookies or other technologies to provide you with marketing information. If you’d like to deactivate all non-essential cookies, hit Customise. You can find out more about how we use cookies and your right to opt-out in our Cookies Policy.",
    "cookie_consent.information.title": "",
    "cxai.browser_toast": "",
    "cxai.default_description": "",
    "cxai.error.message": "",
    "cxai.error.retry": "",
    "cxai.phone_input.mobile_title": "",
    "cxai.phone_input.no_results": "",
    "cxai.phone_input.placeholder": "",
    "cxai.restart.action": "",
    "cxai.restart.close": "",
    "cxai.restart.content": "",
    "cxai.restart.title": "",
    "error_page.action": "Take me home",
    "error_page.subtitle": "Couldn't find the page you were looking for.",
    "error_page.title": "Oops.",
    "footer.disclaimer": "*Price for an excess of \xa3150, contents cover of \xa310,000, for a 2-adult household living in a flat. ~87% of postcodes eligible.\nExcludes where the primary user has made a relevant claim in the last 3 years.\n\n**Price for an excess of \xa3150, contents cover of \xa310,000, for a single adult living in a house.\nExcludes where the primary user has made a relevant claim in the last 5 years.\n\nLemonade Agency B.V., UK Branch (BR024862), 51 Eastcheap, London, EC3M 1DT is the UK establishment of Lemonade Agency B.V. It is authorised and regulated by the Financial Conduct Authority. Lemonade Agency B.V. is registered with the Dutch chamber of commerce (Kamer van Koophandel) with registration number 75134454. (FRN: 989294)\n\nLemonade Insurance N.V., UK branch (BR025196), 51 Eastcheap, London, EC3M 1DT is the UK establishment of Lemonade Insurance N.V. registered with the Dutch chamber of commerce (Kamer van Koophandel) with registration number 73227420. Lemonade Insurance N.V. is licensed as an insurance company by De Nederlandsche Bank in the Netherlands (R162036). Authorised by the Prudential Regulation Authority. Subject to regulation by the Financial Conduct Authority and limited regulation by the Prudential Regulation Authority. Details about the extent of our regulation by the Prudential Regulation Authority are available from us on request. (FRN 846181)",
    "footer.titles.company": "",
    "footer.titles.homeInsurance": "Home Insurance",
    "footer.titles.contentInsurance": "Content Insurance",
    "footer.titles.buildingInsurance": "Building Insurance",
    "footer.titles.features": "",
    "footer.titles.get_app": "",
    "footer.titles.products": "",
    "footer.titles.resources": "",
    "footer.titles.social": "",
    "footer.titles.contact": "",
    "header.actions.login": "My Account",
    "header.actions.logout": "Logout",
    "header.actions.settings": "Settings",
    "header.accessibility.title": "Accessibility",
    "header.api.title": "",
    "header.blank.title": "",
    "header.blog.title": "",
    "header.car.title": "",
    "header.car_explained.title": "",
    "header.claims.title": "",
    "header.community.title": "",
    "header.contents.title": "Contents",
    "header.contents_explanation.title": "Home Insurance Explained",
    "header.covid_19.title": "",
    "header.crypto.title": "Crypto",
    "header.faq.title": "",
    "header.giveback.title": "",
    "header.giveback_2021.title": "",
    "header.global_expansion.title": "",
    "header.gravity.title": "Gravity",
    "header.home.title": "",
    "header.homeowners.title": "",
    "header.imprint.title": "",
    "header.insurance_card.title": "",
    "header.insuropedia.title": "",
    "header.investors.title": "",
    "header.legal_stuff.title": "",
    "header.life.title": "",
    "header.makers.title": "",
    "header.manage_cookies.title": "",
    "header.partners_program.title": "",
    "header.pet.title": "",
    "header.pet_dog_insurance_explained.title": "",
    "header.pet_insurance.title": "",
    "header.policy_two.title": "",
    "header.privacy_policy.title": "Privacy Policy",
    "header.renters.title": "",
    "header.reviews.title": "",
    "header.sitemap.title": "Sitemap",
    "header.term_life.title": "",
    "header.terms_of_service.title": "",
    "header.tips.title": "Tips",
    "header.transparency.title": "",
    "nav.accessibility.title": "Accessibility",
    "nav.api.title": "",
    "nav.global_partners_program.title": "Partners Program",
    "nav.blank.title": "",
    "nav.global_blog_uk.title": "Blog",
    "nav.blog.title": "",
    "nav.global_api.title": "API",
    "nav.car.title": "",
    "nav.car_explained.title": "",
    "nav.claims.title": "",
    "nav.community.title": "",
    "nav.contents.title": "Contents",
    "nav.contents_explanation.title": "Home Insurance Explained",
    "nav.covid_19.title": "",
    "nav.crypto.title": "Crypto",
    "nav.faq.title": "",
    "nav.giveback.title": "",
    "nav.giveback_2021.title": "",
    "nav.global_expansion.title": "",
    "nav.gravity.title": "Gravity",
    "nav.home.title": "",
    "nav.homeowners.title": "",
    "nav.imprint.title": "",
    "nav.insurance_card.title": "",
    "nav.insuropedia.title": "",
    "language.select.label": "Select your language",
    "nav.investors.title": "Investor Relations",
    "nav.legal_stuff.title": "",
    "nav.life.title": "",
    "nav.makers.title": "",
    "nav.manage_cookies.title": "",
    "nav.partners_program.title": "",
    "nav.pet.title": "",
    "nav.pet_dog_insurance_explained.title": "",
    "nav.pet_insurance.title": "",
    "nav.policy_two.title": "",
    "nav.privacy_policy.title": "Privacy Policy",
    "nav.renters.title": "",
    "nav.reviews.title": "",
    "nav.content_insurance_hub.title": "What Is Contents Insurance",
    "nav.content_insurance_cost_hub.title": "Contents Insurance Cost",
    "nav.home_insurance_hub.title": "Home Insurance Explained",
    "nav.home_insurance_coverage_hub.title": "What Does Home Insurance Cover",
    "nav.home_emergency_cover.title": "Home Emergency Cover",
    "nav.flood_insurance.title": "Flood Insurance",
    "nav.building_insurance_hub.title": "What Is Building Insurance",
    "nav.building_insurance_coverage_hub.title": "What Does Building Insurance Cover",
    "nav.building_insurance_cost_hub.title": "How Much Is Building Insurance",
    "nav.sitemap.title": "Sitemap",
    "nav.term_life.title": "",
    "nav.terms_of_service.title": "",
    "nav.tips.title": "Home Insurance explained",
    "nav.transparency.title": "",
    "nav.content_insurance_coverage_hub.title": "How Much Contents Insurance Do I Need",
    "nav.personal_liability_hub.title": "Personal liability",
    "nav.insurance_valuables_items_hub.title": "Insurance for valuable items",
    "nav.bike_insurance_hub.title": "Bike insurance",
    "nav.phone_insurance_hub.title": "Mobile phone insurance",
    "privacy_banner.content": "",
    "privacy_banner.cta": ""
};

export { enGBTranslation as default };
